import { AuthUser } from '@app/account/account-api.model';
import { reportingMapper } from './permission-maps/reporting';

export const mapAuthUserPermissions = (authUser: AuthUser): void => {
  authUser.permissions = {
    reporting: reportingMapper(authUser),
  };
};
